import React from "react";
import styled from "styled-components";

const StyledLabel = styled.div`
  width: 80%;
  background-color: white;
  margin: 0.5em auto;
  color: ${({ value, current, selected, theme }) => value < 0 ? '#ff0000' : (current ? theme.main : (selected ? '#414141' : theme.lightGrey))};
  opacity: ${({ value, current, selected }) => (value < 0 || current) && !selected ? 0.5 : 1};
  font-size: 16px;
  font-weight: 500;
  text-align: center;
`;

const Label = ({ data, ...props }) => (
  <StyledLabel {...props} >
    {props.label}
  </StyledLabel>
);

export default Label;


// WEBPACK FOOTER //
// ./src/artzu-ui/src/BarGraph/Label.js